import { AfterViewInit, Component, ElementRef, Input, OnInit } from '@angular/core';

declare function videojs(id: any, options: any, ready: any): any;

// import videojs from 'videojs'

@Component({
    selector: 'videojs',
    templateUrl: './video-player.component.html'
})

export class VideoPlayerComponent implements OnInit, AfterViewInit {

    // reference to the element itself, we use this to access events and methods
    private _elementRef: ElementRef;

    // index to create unique ID for component
    @Input() idx: string;

    // video asset url
    @Input() url: any;

    // declare player var
    private player: any;

    // constructor initializes our declared vars
    constructor(elementRef: ElementRef) {
        this.url = false;
        this.player = false;
    }

    ngOnInit() {
    }

    // use ngAfterViewInit to make sure we initialize the videojs element
    // after the component template itself has been rendered
    ngAfterViewInit() {

        // ID with which to access the template's video element
        let el = 'video_' + this.idx;

        // setup the player via the unique element ID
        this.player = videojs(document.getElementById('video-player'), {}, function () {
        });

        this.player.ready(() => {

            this.player.panorama({
                PanoramaThumbnail: true, //enable panorama thumbnail
                KeyboardControl: true,
                clickToToggle: true,
                clickAndDrag: true,
                backToHorizonCenter: false,
                backToVerticalCenter: false,
                autoMobileOrientation: true,
                // Notice: {
                //     Enable: true,
                //     Message: (isMobile()) ? "Please drag and drop the video" : "Please use your mouse drag and drop the video"
                // },
            })

        });
    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/app/shared/video-player/video-player.component.ts